// extracted by mini-css-extract-plugin
export default {"table":"style_table__fE04c"};